import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import type { TClientInvoiceDocumentRes } from 'api/swagger';
import { CLIENT_ORDER_INVOICE_DOCUMENTS_GET_MANY } from '../query-keys';

interface IParams {
  enabled: boolean;
}

export const useGetOrderInvoiceDocuments = (orderId: number, params: IParams) => {
  const { enabled } = params;
  return useQuery<TClientInvoiceDocumentRes[]>({
    queryKey: [CLIENT_ORDER_INVOICE_DOCUMENTS_GET_MANY, { orderId }],
    queryFn: async () => {
      const { data } = await http.get<TClientInvoiceDocumentRes[]>(`client-office/v1/orders/${orderId}/invoices`);

      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    cacheTime: 30 * 1000,
    enabled,
  });
};
